import './reset.css';
import './App.css';
import { Routes, Route, Link, useNavigate, Outlet } from 'react-router-dom'
import MainEvent from './Event/Event.js'
import SubEvent1 from './Event/Subevent1.js'
import SubEvent2 from './Event/Subevent2.js'
import SubEventEnd1 from './Event/SubeventEnd1.js'
import SubEventEnd2 from './Event/SubeventEnd2.js'



function App() {

  let navigate = useNavigate();

  return (
    <>

      <header>
        <div class="logo"><Link to='/'><p>구독케어</p></Link></div>
        <div class="menu">
          {/* <div className='ham'>
            <span></span>
            <span></span>
            <span></span>
          </div> */}
          <ul>
            <li><p>구독케어</p></li>
            <li><p>동반여행</p></li>
            <li><p><Link to="community">커뮤니티</Link></p></li>
            <li><p>댕댕뉴스</p></li>
            <li><p><Link to="event">이벤트</Link></p></li>
          </ul>
          <div class="search">
            <input type="text" />
            <button class="search_btn"></button>
          </div>
        </div>
      </header>

      <Routes>
        {/* 메인페이지 */}
        <Route path="/" element={ 
        <>
          <section className='main-banner'>
            <div><img src={process.env.PUBLIC_URL + '/img/main_slide.jpg'} /></div>
          </section>

          <section className='main-event'>
            <div className='main-event-logo'>
              <div><img src={process.env.PUBLIC_URL + '/img/menu-icon.png'} /></div>
              <Link to="/event"><h1>EVENT</h1></Link>
            </div>
            
            <div className='event'>
              <EVENT />
              <EVENT />
              <EVENT />
            </div>
          </section>

          <section className='community'>
            <div className='community-logo'>
              <div><img src={process.env.PUBLIC_URL + '/img/menu-icon.png'} /></div>
              <h1><strong>COMMUNITY</strong> 게시판</h1>
            </div>
            <div className='community-board'>
              <COMMUNITY />
              <COMMUNITY />
              <COMMUNITY />
            </div>
            <div className='community-btn'><button><p>더보기</p></button></div>
          </section>

          <section className='gallery'>
            <div className='gallery-logo'>
              <div><img src={process.env.PUBLIC_URL + '/img/menu-icon.png'} /></div>
              <h1><strong>GALLERY</strong> 멍사진</h1>
            </div>
            <div className='dog-gallery'>
              <GALLERY />
              <GALLERY />
              <GALLERY />
              <GALLERY />
              <GALLERY />
            </div>
            <div className='gallery-btn'><button><p>더보기</p></button></div>
          </section>

          <section className='two-content'>
            <div className='notice'>
              <h1><strong>NOTICE</strong> 공지사항</h1>
              <div className='notice-board'>
                <NOTICE />
                <NOTICE />
                <NOTICE />
                <NOTICE />
                <NOTICE />
              </div>
            </div>
            <div className='video'>
              <h1><strong>VIDEO</strong> 멍튜브</h1>
              <div className='video-board'>
                <VIDEO />
                <VIDEO />
              </div>
            </div>
          </section>

          {/* 제휴문의하기 */}
          <section className='contact'>
            <div className='contact-main'>
              <h1>CONTACT US</h1>
              <div className='contact-img'></div>
            </div>
            <div className='contact-sub'>
              <button><p>제휴문의하기</p><i class="fa-solid fa-greater-than"></i></button>
            </div>
          </section>



        </> 
        } />

        {/* 이벤트페이지 */}
        <Route path="/event" element={ <MainEvent /> } />
        {/* 이벤트페이지 서브1 */}
        <Route path='/event/event1' element={<SubEvent1 />}>
        </Route>
        {/* 이벤트페이지 서브2 */}
        <Route  path='/event/event2'  element={<SubEvent2 />}>
        </Route>
        {/* 이벤트페이지 서브 이벤트종료1 */}
        <Route  path='/event/end-event1'  element={<SubEventEnd1 />}>
        </Route>
        {/* 이벤트페이지 서브 이벤트종료2 */}
        <Route  path='/event/end-event2'  element={<SubEventEnd2 />}>
        </Route>

        <Route path='/community'>

        </Route>



      </Routes>

      <footer className='ft'>
        <div className='ft-sub'>
          <h1>COMPANY INFO</h1>
          <div className='ft-sub-introduction'>
            <div>
              <span>회사명 <strong>구독케어</strong></span>
              <span>대표 <strong>심규남</strong></span>
              <span>대표전화 <strong>070-1111-1111</strong></span>
              <span>팩스 <strong>02-412-1425</strong></span>
            </div>
            <div>
              <span>주소 <strong>대전 서구 계룡로 639 에이스침대 대전사옥 2층</strong></span>
            </div>
            <div>
              <span>사업자 등록번호 <strong>305-28-17040</strong></span>
              <span>통신판매업 신고 <strong>제 2023-대전서구-1621호</strong></span>
              <button><p>사업자정보확인</p><Link></Link></button>
            </div>
            <div>
              <span>개인정보관리책임자 <strong>길형인</strong></span>
              <span>이메일 <strong>khi94@planittour.co.kr</strong></span>
            </div>
            
          </div>
        </div>
      </footer>

      
    </>
  );
}

function EVENT() {

  

  return(
    <>
      <div className='event-img'>
        <image></image>
      </div>
    </>
  );
}

function COMMUNITY() {
  return(
    <>
      <div className='community-content'>
        <div className='community-content-img'><img src='' /></div>
        <div className='community-content-p'>
          <div>
            <h1>제목</h1>
            <h2>내용<br /> 내용</h2>
          </div>
          <p>닉네임 <strong>2024.02.04</strong></p>
        </div>
      </div>
    </>
  );
}

function GALLERY() {
  return(
    <>
      <div className='gallery-content'>
        <div><img src='' /></div>
      </div>
    </>
  );
}

function NOTICE() {
  return(
    <>
      <div className='notice-content'><p>공지사항 1</p></div>
    </>
  );
}

function VIDEO() {
  return(
    <>
      <div className='video-content'><p>영상</p></div>
    </>
  );
}


export default App;
